import { render } from "./LungCancerView.vue?vue&type=template&id=f9c8933c"
import script from "./LungCancerView.vue?vue&type=script&lang=js"
export * from "./LungCancerView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__